import Spinner from 'components/Spinner'
import React, { useState } from 'react'
import useSWR from 'swr'
import ReviewComment from './components/Comment'
import { ReviewContext } from './components/reviewContext'
import ReviewsTable from './components/ReviewsTable'

function Review() {

  const { data: branchesRatings } = useSWR('merchants/ratings')

  const [showReviewChart, setShowReviewChart] = useState(false)
  const [showComment, setShowComment] = useState(false)
  const [currentPage, setCurrentPage] = useState({ header: 'Reviews', page: 'table', branchId: 1 })
  const [currentBranch, setCurrentBranch] = useState({})

  return (
    <ReviewContext.Provider value={{ showReviewChart, setShowReviewChart, showComment, setShowComment, currentPage, setCurrentPage, currentBranch, setCurrentBranch }}>
      <div className='bg-white w-[100%] h-[80vh] p-5 rounded-[16px]'>

        <div className='font-bold text-[#657585] h-[10%]' style={{ fontSize: '2rem' }}>Reviews</div>

        <div className='h-[90%] w-100 pt-3'>

          {branchesRatings?.data ? (!showComment && !showReviewChart ? <ReviewsTable branchesRatings={branchesRatings} /> : null) : <Spinner />}
          {showComment && <ReviewComment currentBranch={currentBranch} />}
          {/* <EmtpyReview /> */}

        </div>

      </div>
    </ReviewContext.Provider>
  )
}

export default Review